module.exports = __webpack_public_path__ + "img/ideavr_intro.e3c3d5fa.png";